/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Starts process of Initializes database with data from csv-files.
     * @return Success
     */
    initializeDatabase(): Promise<string> {
        let url_ = this.baseUrl + "/api/v0.1/administration/initializedatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeDatabase(_response);
        });
    }

    protected processInitializeDatabase(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Starts process of Initializes InMemoryDatabase with data from json-files.
     * @return Success
     */
    initializeInMemoryDatabase(): Promise<string> {
        let url_ = this.baseUrl + "/api/v0.1/administration/initializeinmemorydatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeInMemoryDatabase(_response);
        });
    }

    protected processInitializeInMemoryDatabase(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes all Nodes from Database.
     * @return Success
     */
    deleteDatabase(): Promise<string> {
        let url_ = this.baseUrl + "/api/v0.1/administration/deletedatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDatabase(_response);
        });
    }

    protected processDeleteDatabase(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Resets Nodes in Database.
     * @return Success
     */
    resetDatabase(): Promise<string> {
        let url_ = this.baseUrl + "/api/v0.1/administration/resetdatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetDatabase(_response);
        });
    }

    protected processResetDatabase(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the heartbeat from the api.
     * @return Success
     */
    sayHi(): Promise<string> {
        let url_ = this.baseUrl + "/api/v0.1/administration/sayhi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSayHi(_response);
        });
    }

    protected processSayHi(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Checks if server has connection to database.
     * @return Success
     */
    checkDatabase(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v0.1/administration/checkdatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckDatabase(_response);
        });
    }

    protected processCheckDatabase(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets all UseCases from DB.
     * @return Success
     */
    getAllUsecases(): Promise<UseCase[]> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getusecases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsecases(_response);
        });
    }

    protected processGetAllUsecases(response: Response): Promise<UseCase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UseCase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseCase[]>(null as any);
    }

    /**
     * Gets all TreeNodes from DB that belong to given UseCase.
     * @return Success
     */
    getTreeNodesByUseCase(useCaseId: number): Promise<TreeNode[]> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/gettreenodesbyusecase/{useCaseId}";
        if (useCaseId === undefined || useCaseId === null)
            throw new Error("The parameter 'useCaseId' must be defined.");
        url_ = url_.replace("{useCaseId}", encodeURIComponent("" + useCaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodesByUseCase(_response);
        });
    }

    protected processGetTreeNodesByUseCase(response: Response): Promise<TreeNode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNode[]>(null as any);
    }

    /**
     * Gets all TreeNodes from DB that belong to given TreeNode.
     * @return Success
     */
    getTreeNodesByTreeNode(treeNodeId: number): Promise<TreeNode[]> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/gettreenodesbytreenode/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodesByTreeNode(_response);
        });
    }

    protected processGetTreeNodesByTreeNode(response: Response): Promise<TreeNode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNode[]>(null as any);
    }

    /**
     * Gets all Usecases from DB that belong to given TreeNode.
     * @return Success
     */
    getUseCaseTree(useCaseId: number): Promise<any[]> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getusecasetree/{useCaseId}";
        if (useCaseId === undefined || useCaseId === null)
            throw new Error("The parameter 'useCaseId' must be defined.");
        url_ = url_.replace("{useCaseId}", encodeURIComponent("" + useCaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUseCaseTree(_response);
        });
    }

    protected processGetUseCaseTree(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * Gets Category by given TreeNode from DB.
     * @return Success
     */
    getCategoryByTreeNode(treeNodeId: number): Promise<Classification> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getcategorybytreenode/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCategoryByTreeNode(_response);
        });
    }

    protected processGetCategoryByTreeNode(response: Response): Promise<Classification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Classification.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Classification>(null as any);
    }

    /**
     * Gets Property Definition Groups by the given classification.
     * @return Success
     */
    getPropertyDefinitionGroupByClassificationName(classification: string | null): Promise<PropertyDefinitionGroup[]> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getpropertydefinitiongroupbyclassificationname/{classification}";
        if (classification === undefined || classification === null)
            throw new Error("The parameter 'classification' must be defined.");
        url_ = url_.replace("{classification}", encodeURIComponent("" + classification));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyDefinitionGroupByClassificationName(_response);
        });
    }

    protected processGetPropertyDefinitionGroupByClassificationName(response: Response): Promise<PropertyDefinitionGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyDefinitionGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDefinitionGroup[]>(null as any);
    }

    /**
     * Gets Property Definition Groups by the given revitName.
     * @return Success
     */
    getPropertyDefinitionGroupByRevitName(revitName: string | null): Promise<PropertyDefinitionGroup> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getpropertydefinitiongroupbyrevitname/{revitName}";
        if (revitName === undefined || revitName === null)
            throw new Error("The parameter 'revitName' must be defined.");
        url_ = url_.replace("{revitName}", encodeURIComponent("" + revitName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyDefinitionGroupByRevitName(_response);
        });
    }

    protected processGetPropertyDefinitionGroupByRevitName(response: Response): Promise<PropertyDefinitionGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDefinitionGroup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDefinitionGroup>(null as any);
    }

    /**
     * Gets Properties by given PartID.
     * @return Success
     */
    getPropertyByGivenPartID(partId: number): Promise<{ [key: string]: { [key: string]: string; }; }> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getpropertybygivenpartid/{partId}";
        if (partId === undefined || partId === null)
            throw new Error("The parameter 'partId' must be defined.");
        url_ = url_.replace("{partId}", encodeURIComponent("" + partId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyByGivenPartID(_response);
        });
    }

    protected processGetPropertyByGivenPartID(response: Response): Promise<{ [key: string]: { [key: string]: string; }; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: { [key: string]: string; }; }>(null as any);
    }

    /**
     * Gets Category by given TreeNode from DB.
     * @return Success
     */
    getProductPropertiesById(id: string | null): Promise<ProductProperties> {
        let url_ = this.baseUrl + "/api/v0.1/dashboard/getproductpropertiesbyid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductPropertiesById(_response);
        });
    }

    protected processGetProductPropertiesById(response: Response): Promise<ProductProperties> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductProperties.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = StatusCodeResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductProperties>(null as any);
    }

    /**
     * Gets dbId from DB that belong to given TreeNode.
     * @return Success
     */
    getdbIdByTreeNode(treeNodeId: number): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v0.1/forgeviewer/getdbidbytreenode/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetdbIdByTreeNode(_response);
        });
    }

    protected processGetdbIdByTreeNode(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Gets single Product from TreeNodeId-
     * @return Success
     */
    getproductbytreenodeid(treenodeid: number): Promise<Product> {
        let url_ = this.baseUrl + "/api/v0.1/forgeviewer/getproductbytreenodeid/{treenodeid}";
        if (treenodeid === undefined || treenodeid === null)
            throw new Error("The parameter 'treenodeid' must be defined.");
        url_ = url_.replace("{treenodeid}", encodeURIComponent("" + treenodeid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetproductbytreenodeid(_response);
        });
    }

    protected processGetproductbytreenodeid(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * Gets ModelNode for given UseCaseId.
     * @return Success
     */
    getModelsByUseCase(usecaseid: number): Promise<ModelNode[]> {
        let url_ = this.baseUrl + "/api/v0.1/forgeviewer/getmodelsbyusecase/{usecaseid}";
        if (usecaseid === undefined || usecaseid === null)
            throw new Error("The parameter 'usecaseid' must be defined.");
        url_ = url_.replace("{usecaseid}", encodeURIComponent("" + usecaseid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetModelsByUseCase(_response);
        });
    }

    protected processGetModelsByUseCase(response: Response): Promise<ModelNode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelNode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelNode[]>(null as any);
    }

    /**
     * Gets product by given dbid from DB.
     * @return Success
     */
    getProductByDbId(dbId: number): Promise<Product> {
        let url_ = this.baseUrl + "/api/v0.1/productcatalog/getproductbydbid/{dbId}";
        if (dbId === undefined || dbId === null)
            throw new Error("The parameter 'dbId' must be defined.");
        url_ = url_.replace("{dbId}", encodeURIComponent("" + dbId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductByDbId(_response);
        });
    }

    protected processGetProductByDbId(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * Gets CatalogModel by given categoryId and manufacturerId from DB.
     * @return Success
     */
    getCatalogModelByCategoryAndManufacturer(categoryId: number, manufacturerId: number): Promise<CatalogModel> {
        let url_ = this.baseUrl + "/api/v0.1/productcatalog/getcatalogmodelbycategoryandmanufacturer/{categoryId}/{manufacturerId}";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (manufacturerId === undefined || manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' must be defined.");
        url_ = url_.replace("{manufacturerId}", encodeURIComponent("" + manufacturerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCatalogModelByCategoryAndManufacturer(_response);
        });
    }

    protected processGetCatalogModelByCategoryAndManufacturer(response: Response): Promise<CatalogModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogModel>(null as any);
    }

    /**
     * Gets all PropertyStorages from DB, if there are no Entries in the DB, the List will be empty
     * @return Success
     */
    getAllPropertyStorages(): Promise<PropertyStorage[]> {
        let url_ = this.baseUrl + "/api/v0.1/propertystorage/get/propertystorages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPropertyStorages(_response);
        });
    }

    protected processGetAllPropertyStorages(response: Response): Promise<PropertyStorage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyStorage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyStorage[]>(null as any);
    }

    /**
     * saves the propertystorage if it nor already exists
     * @param body (optional) 
     * @return Success
     */
    savePropertyStorage(body: PropertyStorage | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v0.1/propertystorage/post/propertystorages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSavePropertyStorage(_response);
        });
    }

    protected processSavePropertyStorage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates propertyStorage if it exists
     * @param body (optional) 
     * @return Success
     */
    updatePropertyStorage(body: PropertyStorage | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v0.1/propertystorage/put/propertystorages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePropertyStorage(_response);
        });
    }

    protected processUpdatePropertyStorage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets PropertyStorage with the given revit id or null if there is no entry with that it
     * @return Success
     */
    getPropertyStorageByRevitIdAndProductID(revitId: string | null, productId: number): Promise<PropertyStorage> {
        let url_ = this.baseUrl + "/api/v0.1/propertystorage/get/propertystorages/{revitId}/{productId}";
        if (revitId === undefined || revitId === null)
            throw new Error("The parameter 'revitId' must be defined.");
        url_ = url_.replace("{revitId}", encodeURIComponent("" + revitId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyStorageByRevitIdAndProductID(_response);
        });
    }

    protected processGetPropertyStorageByRevitIdAndProductID(response: Response): Promise<PropertyStorage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyStorage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyStorage>(null as any);
    }

    /**
     * Saves all PropertyStorages, if there are entries in the db with the same key, as one of the given PropertyStorges,the entry will be overrriden
     * @param body (optional) 
     * @return Success
     */
    saveAllPropertyStorages(body: PropertyStorage[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v0.1/propertystorage/post/propertystorages/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAllPropertyStorages(_response);
        });
    }

    protected processSaveAllPropertyStorages(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the TreeNode ids matching the given UseCase.
     * @return Success
     */
    getTreeNodeIdsByUseCase(useCaseId: number): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v0.1/usecase/gettreenodeidsbyusecase/{useCaseId}";
        if (useCaseId === undefined || useCaseId === null)
            throw new Error("The parameter 'useCaseId' must be defined.");
        url_ = url_.replace("{useCaseId}", encodeURIComponent("" + useCaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeIdsByUseCase(_response);
        });
    }

    protected processGetTreeNodeIdsByUseCase(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class UseCase implements IUseCase {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    image?: string | undefined;

    constructor(data?: IUseCase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UseCase {
        data = typeof data === 'object' ? data : {};
        let result = new UseCase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["image"] = this.image;
        return data;
    }
}

export interface IUseCase {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    image?: string | undefined;
}

export class TreeNode implements ITreeNode {
    id?: number;
    name?: string | undefined;
    isGeneric?: boolean;

    constructor(data?: ITreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isGeneric = _data["isGeneric"];
        }
    }

    static fromJS(data: any): TreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isGeneric"] = this.isGeneric;
        return data;
    }
}

export interface ITreeNode {
    id?: number;
    name?: string | undefined;
    isGeneric?: boolean;
}

export class Classification implements IClassification {
    id?: number;
    name?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IClassification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): Classification {
        data = typeof data === 'object' ? data : {};
        let result = new Classification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IClassification {
    id?: number;
    name?: string | undefined;
    icon?: string | undefined;
}

export class PropertyDefinitionGroupName implements IPropertyDefinitionGroupName {
    bimq?: string | undefined;
    revit?: string | undefined;

    constructor(data?: IPropertyDefinitionGroupName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bimq = _data["bimq"];
            this.revit = _data["revit"];
        }
    }

    static fromJS(data: any): PropertyDefinitionGroupName {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinitionGroupName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bimq"] = this.bimq;
        data["revit"] = this.revit;
        return data;
    }
}

export interface IPropertyDefinitionGroupName {
    bimq?: string | undefined;
    revit?: string | undefined;
}

export class DefinitionNameRevit implements IDefinitionNameRevit {
    id?: string | undefined;
    built_in?: boolean;
    value?: string | undefined;

    constructor(data?: IDefinitionNameRevit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.built_in = _data["built_in"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DefinitionNameRevit {
        data = typeof data === 'object' ? data : {};
        let result = new DefinitionNameRevit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["built_in"] = this.built_in;
        data["value"] = this.value;
        return data;
    }
}

export interface IDefinitionNameRevit {
    id?: string | undefined;
    built_in?: boolean;
    value?: string | undefined;
}

export class PropertyDefinitionName implements IPropertyDefinitionName {
    bimq?: string | undefined;
    revit?: DefinitionNameRevit;

    constructor(data?: IPropertyDefinitionName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bimq = _data["bimq"];
            this.revit = _data["revit"] ? DefinitionNameRevit.fromJS(_data["revit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyDefinitionName {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinitionName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bimq"] = this.bimq;
        data["revit"] = this.revit ? this.revit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyDefinitionName {
    bimq?: string | undefined;
    revit?: DefinitionNameRevit;
}

export class ValueType implements IValueType {
    unit?: string | undefined;
    text?: string | undefined;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    defaultValue?: string | undefined;

    constructor(data?: IValueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"];
            this.text = _data["text"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ValueType {
        data = typeof data === 'object' ? data : {};
        let result = new ValueType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["text"] = this.text;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IValueType {
    unit?: string | undefined;
    text?: string | undefined;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    defaultValue?: string | undefined;
}

export class SingleValueDescriptor implements ISingleValueDescriptor {
    valueType?: ValueType;

    constructor(data?: ISingleValueDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueType = _data["valueType"] ? ValueType.fromJS(_data["valueType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleValueDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new SingleValueDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueType"] = this.valueType ? this.valueType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleValueDescriptor {
    valueType?: ValueType;
}

export class EnumerationValueDescriptorEntryValueVariant implements IEnumerationValueDescriptorEntryValueVariant {
    value?: string | undefined;

    constructor(data?: IEnumerationValueDescriptorEntryValueVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumerationValueDescriptorEntryValueVariant {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptorEntryValueVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumerationValueDescriptorEntryValueVariant {
    value?: string | undefined;
}

export class EnumerationValueDescriptorEntryValue implements IEnumerationValueDescriptorEntryValue {
    variant?: EnumerationValueDescriptorEntryValueVariant;
    empty?: boolean;

    constructor(data?: IEnumerationValueDescriptorEntryValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variant = _data["variant"] ? EnumerationValueDescriptorEntryValueVariant.fromJS(_data["variant"]) : <any>undefined;
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): EnumerationValueDescriptorEntryValue {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptorEntryValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IEnumerationValueDescriptorEntryValue {
    variant?: EnumerationValueDescriptorEntryValueVariant;
    empty?: boolean;
}

export class EnumerationValueDescriptorEntry implements IEnumerationValueDescriptorEntry {
    key?: string | undefined;
    value?: EnumerationValueDescriptorEntryValue;

    constructor(data?: IEnumerationValueDescriptorEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? EnumerationValueDescriptorEntryValue.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnumerationValueDescriptorEntry {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptorEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnumerationValueDescriptorEntry {
    key?: string | undefined;
    value?: EnumerationValueDescriptorEntryValue;
}

export class EnumerationValueDescriptorValuesOrderVariant implements IEnumerationValueDescriptorValuesOrderVariant {
    value?: string | undefined;

    constructor(data?: IEnumerationValueDescriptorValuesOrderVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumerationValueDescriptorValuesOrderVariant {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptorValuesOrderVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumerationValueDescriptorValuesOrderVariant {
    value?: string | undefined;
}

export class EnumerationValueDescriptorValuesOrder implements IEnumerationValueDescriptorValuesOrder {
    variant?: EnumerationValueDescriptorValuesOrderVariant[] | undefined;
    valuesNum?: number;

    constructor(data?: IEnumerationValueDescriptorValuesOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["variant"])) {
                this.variant = [] as any;
                for (let item of _data["variant"])
                    this.variant!.push(EnumerationValueDescriptorValuesOrderVariant.fromJS(item));
            }
            this.valuesNum = _data["valuesNum"];
        }
    }

    static fromJS(data: any): EnumerationValueDescriptorValuesOrder {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptorValuesOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.variant)) {
            data["variant"] = [];
            for (let item of this.variant)
                data["variant"].push(item.toJSON());
        }
        data["valuesNum"] = this.valuesNum;
        return data;
    }
}

export interface IEnumerationValueDescriptorValuesOrder {
    variant?: EnumerationValueDescriptorValuesOrderVariant[] | undefined;
    valuesNum?: number;
}

export class EnumerationValueDescriptor implements IEnumerationValueDescriptor {
    singleValueDescriptor?: SingleValueDescriptor;
    hasMultiValue?: boolean;
    values?: EnumerationValueDescriptorEntry[] | undefined;
    valuesOrder?: EnumerationValueDescriptorValuesOrder;

    constructor(data?: IEnumerationValueDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleValueDescriptor = _data["singleValueDescriptor"] ? SingleValueDescriptor.fromJS(_data["singleValueDescriptor"]) : <any>undefined;
            this.hasMultiValue = _data["hasMultiValue"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(EnumerationValueDescriptorEntry.fromJS(item));
            }
            this.valuesOrder = _data["valuesOrder"] ? EnumerationValueDescriptorValuesOrder.fromJS(_data["valuesOrder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnumerationValueDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationValueDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleValueDescriptor"] = this.singleValueDescriptor ? this.singleValueDescriptor.toJSON() : <any>undefined;
        data["hasMultiValue"] = this.hasMultiValue;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["valuesOrder"] = this.valuesOrder ? this.valuesOrder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnumerationValueDescriptor {
    singleValueDescriptor?: SingleValueDescriptor;
    hasMultiValue?: boolean;
    values?: EnumerationValueDescriptorEntry[] | undefined;
    valuesOrder?: EnumerationValueDescriptorValuesOrder;
}

export class ValueDescriptor implements IValueDescriptor {
    singleValueDescriptor?: SingleValueDescriptor;
    enumerationValueDescriptor?: EnumerationValueDescriptor;

    constructor(data?: IValueDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleValueDescriptor = _data["singleValueDescriptor"] ? SingleValueDescriptor.fromJS(_data["singleValueDescriptor"]) : <any>undefined;
            this.enumerationValueDescriptor = _data["enumerationValueDescriptor"] ? EnumerationValueDescriptor.fromJS(_data["enumerationValueDescriptor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValueDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new ValueDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleValueDescriptor"] = this.singleValueDescriptor ? this.singleValueDescriptor.toJSON() : <any>undefined;
        data["enumerationValueDescriptor"] = this.enumerationValueDescriptor ? this.enumerationValueDescriptor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueDescriptor {
    singleValueDescriptor?: SingleValueDescriptor;
    enumerationValueDescriptor?: EnumerationValueDescriptor;
}

export class CategoryId implements ICategoryId {
    pname?: string | undefined;
    pvalue?: string | undefined;
    text?: string | undefined;

    constructor(data?: ICategoryId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pname = _data["pname"];
            this.pvalue = _data["pvalue"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CategoryId {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pname"] = this.pname;
        data["pvalue"] = this.pvalue;
        data["text"] = this.text;
        return data;
    }
}

export interface ICategoryId {
    pname?: string | undefined;
    pvalue?: string | undefined;
    text?: string | undefined;
}

export class AvailabilityItem implements IAvailabilityItem {
    categoryId?: CategoryId;

    constructor(data?: IAvailabilityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"] ? CategoryId.fromJS(_data["categoryId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityItem {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId ? this.categoryId.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityItem {
    categoryId?: CategoryId;
}

export class PropertyDefinitionAvailability implements IPropertyDefinitionAvailability {
    propertyAvailability?: any | undefined;
    availabilityItems?: AvailabilityItem[] | undefined;

    constructor(data?: IPropertyDefinitionAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyAvailability = _data["propertyAvailability"];
            if (Array.isArray(_data["availabilityItems"])) {
                this.availabilityItems = [] as any;
                for (let item of _data["availabilityItems"])
                    this.availabilityItems!.push(AvailabilityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyDefinitionAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinitionAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyAvailability"] = this.propertyAvailability;
        if (Array.isArray(this.availabilityItems)) {
            data["availabilityItems"] = [];
            for (let item of this.availabilityItems)
                data["availabilityItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyDefinitionAvailability {
    propertyAvailability?: any | undefined;
    availabilityItems?: AvailabilityItem[] | undefined;
}

export class PropertyDefinition implements IPropertyDefinition {
    pdName?: PropertyDefinitionName;
    description?: string | undefined;
    readonly?: boolean;
    required?: boolean;
    instanceParameter?: boolean;
    valueDescriptor?: ValueDescriptor;
    availability?: PropertyDefinitionAvailability;

    constructor(data?: IPropertyDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdName = _data["pdName"] ? PropertyDefinitionName.fromJS(_data["pdName"]) : <any>undefined;
            this.description = _data["description"];
            this.readonly = _data["readonly"];
            this.required = _data["required"];
            this.instanceParameter = _data["instanceParameter"];
            this.valueDescriptor = _data["valueDescriptor"] ? ValueDescriptor.fromJS(_data["valueDescriptor"]) : <any>undefined;
            this.availability = _data["availability"] ? PropertyDefinitionAvailability.fromJS(_data["availability"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdName"] = this.pdName ? this.pdName.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["readonly"] = this.readonly;
        data["required"] = this.required;
        data["instanceParameter"] = this.instanceParameter;
        data["valueDescriptor"] = this.valueDescriptor ? this.valueDescriptor.toJSON() : <any>undefined;
        data["availability"] = this.availability ? this.availability.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyDefinition {
    pdName?: PropertyDefinitionName;
    description?: string | undefined;
    readonly?: boolean;
    required?: boolean;
    instanceParameter?: boolean;
    valueDescriptor?: ValueDescriptor;
    availability?: PropertyDefinitionAvailability;
}

export class PropertyDefinitionGroup implements IPropertyDefinitionGroup {
    pdgName?: PropertyDefinitionGroupName;
    propertyDefinitions?: PropertyDefinition[] | undefined;

    constructor(data?: IPropertyDefinitionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdgName = _data["pdgName"] ? PropertyDefinitionGroupName.fromJS(_data["pdgName"]) : <any>undefined;
            if (Array.isArray(_data["propertyDefinitions"])) {
                this.propertyDefinitions = [] as any;
                for (let item of _data["propertyDefinitions"])
                    this.propertyDefinitions!.push(PropertyDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyDefinitionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinitionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdgName"] = this.pdgName ? this.pdgName.toJSON() : <any>undefined;
        if (Array.isArray(this.propertyDefinitions)) {
            data["propertyDefinitions"] = [];
            for (let item of this.propertyDefinitions)
                data["propertyDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyDefinitionGroup {
    pdgName?: PropertyDefinitionGroupName;
    propertyDefinitions?: PropertyDefinition[] | undefined;
}

export class PropertyDefinition2 implements IPropertyDefinition2 {
    id?: number;
    bimq?: string | undefined;
    value?: string | undefined;
    validValues?: string | undefined;

    constructor(data?: IPropertyDefinition2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bimq = _data["bimq"];
            this.value = _data["value"];
            this.validValues = _data["validValues"];
        }
    }

    static fromJS(data: any): PropertyDefinition2 {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinition2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bimq"] = this.bimq;
        data["value"] = this.value;
        data["validValues"] = this.validValues;
        return data;
    }
}

export interface IPropertyDefinition2 {
    id?: number;
    bimq?: string | undefined;
    value?: string | undefined;
    validValues?: string | undefined;
}

export class PropertyDefinitionGroup2 implements IPropertyDefinitionGroup2 {
    id?: number;
    pdgName?: string | undefined;
    propertyDefinitions?: PropertyDefinition2[] | undefined;

    constructor(data?: IPropertyDefinitionGroup2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pdgName = _data["pdgName"];
            if (Array.isArray(_data["propertyDefinitions"])) {
                this.propertyDefinitions = [] as any;
                for (let item of _data["propertyDefinitions"])
                    this.propertyDefinitions!.push(PropertyDefinition2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyDefinitionGroup2 {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDefinitionGroup2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pdgName"] = this.pdgName;
        if (Array.isArray(this.propertyDefinitions)) {
            data["propertyDefinitions"] = [];
            for (let item of this.propertyDefinitions)
                data["propertyDefinitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyDefinitionGroup2 {
    id?: number;
    pdgName?: string | undefined;
    propertyDefinitions?: PropertyDefinition2[] | undefined;
}

export class ProductProperties implements IProductProperties {
    id?: string | undefined;
    productUrl?: string | undefined;
    propertyDefinitionGroup?: PropertyDefinitionGroup2[] | undefined;

    constructor(data?: IProductProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productUrl = _data["productUrl"];
            if (Array.isArray(_data["propertyDefinitionGroup"])) {
                this.propertyDefinitionGroup = [] as any;
                for (let item of _data["propertyDefinitionGroup"])
                    this.propertyDefinitionGroup!.push(PropertyDefinitionGroup2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productUrl"] = this.productUrl;
        if (Array.isArray(this.propertyDefinitionGroup)) {
            data["propertyDefinitionGroup"] = [];
            for (let item of this.propertyDefinitionGroup)
                data["propertyDefinitionGroup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductProperties {
    id?: string | undefined;
    productUrl?: string | undefined;
    propertyDefinitionGroup?: PropertyDefinitionGroup2[] | undefined;
}

export class StatusCodeResult implements IStatusCodeResult {
    readonly statusCode?: number;

    constructor(data?: IStatusCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): StatusCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IStatusCodeResult {
    statusCode?: number;
}

export class Product implements IProduct {
    id?: number;
    dbId?: number;
    name?: string | undefined;
    productDetailLink?: string | undefined;
    isGeneric?: boolean;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dbId = _data["dbId"];
            this.name = _data["name"];
            this.productDetailLink = _data["productDetailLink"];
            this.isGeneric = _data["isGeneric"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dbId"] = this.dbId;
        data["name"] = this.name;
        data["productDetailLink"] = this.productDetailLink;
        data["isGeneric"] = this.isGeneric;
        return data;
    }
}

export interface IProduct {
    id?: number;
    dbId?: number;
    name?: string | undefined;
    productDetailLink?: string | undefined;
    isGeneric?: boolean;
}

export class ModelNode implements IModelNode {
    id?: number;
    urn?: string | undefined;

    constructor(data?: IModelNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.urn = _data["urn"];
        }
    }

    static fromJS(data: any): ModelNode {
        data = typeof data === 'object' ? data : {};
        let result = new ModelNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["urn"] = this.urn;
        return data;
    }
}

export interface IModelNode {
    id?: number;
    urn?: string | undefined;
}

export class CatalogModel implements ICatalogModel {
    id?: number;
    link?: string | undefined;

    constructor(data?: ICatalogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): CatalogModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        return data;
    }
}

export interface ICatalogModel {
    id?: number;
    link?: string | undefined;
}

export class PropertyElement implements IPropertyElement {
    id?: number;
    propertyName?: string | undefined;
    propertyValue?: string | undefined;
    valueType?: string | undefined;

    constructor(data?: IPropertyElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyName = _data["propertyName"];
            this.propertyValue = _data["propertyValue"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): PropertyElement {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyName"] = this.propertyName;
        data["propertyValue"] = this.propertyValue;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface IPropertyElement {
    id?: number;
    propertyName?: string | undefined;
    propertyValue?: string | undefined;
    valueType?: string | undefined;
}

export class PropertyStorage implements IPropertyStorage {
    revitID?: string | undefined;
    properties?: PropertyElement[] | undefined;
    productID?: string | undefined;

    constructor(data?: IPropertyStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revitID = _data["revitID"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyElement.fromJS(item));
            }
            this.productID = _data["productID"];
        }
    }

    static fromJS(data: any): PropertyStorage {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revitID"] = this.revitID;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["productID"] = this.productID;
        return data;
    }
}

export interface IPropertyStorage {
    revitID?: string | undefined;
    properties?: PropertyElement[] | undefined;
    productID?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}